import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AdsService } from '../ads.service';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';

@Component({
  selector: 'app-setup',
  templateUrl: './setup.component.html',
  styleUrls: ['./setup.component.css'],
})
export class SetupComponent implements OnInit, OnDestroy {
  constructor(
    private router: Router,
    private adsService: AdsService,
    private localStorageService: LocalStorageService
  ) {}

  public setupSub: Subscription = new Subscription();

  public setupSteps: any = [
    { label: 1, name: 'Website URL' },
    { label: 2, name: 'Account Setup' },
    { label: 3, name: 'Install Extension' },
  ];
  public selectedStepIndex: number = 0;

  public selectedEmail: string = '';
  public customerId: string = '';
  public accessToken: string = '';
  public customerAdsAccount: any = [];

  public extensionInstalled: boolean = false;
  public checkingExtensionStatus: boolean = false;

  public checkingExtensionStatusInterval: any;
  public checkingExtensionStatusIntervalTime: number = 1000;

  public connectionUnsuccessful: boolean = false;

  public websiteUrl: string = '';
  public websiteUrlError: string = '';

  public isDarkMode: boolean = false;

  ngOnInit(): void {
    const params = new URLSearchParams(window.location.search);
    params.forEach((value, key) => {
      if (key === 'connection' && value === 'unsuccessful') {
        this.connectionUnsuccessful = true;
      }
    });

    this.isDarkMode = this.localStorageService.get('darkMode') || false;
    if (this.isDarkMode) {
      document.body.classList.remove('dark-theme');
    }

    this.websiteUrl = sessionStorage.getItem('bhm_ads_website_url') || '';
    this.customerAdsAccount =
      JSON.parse(sessionStorage.getItem('bhm_ads_info') || '{}')?.customers ||
      [];

    this.selectedEmail =
      JSON.parse(sessionStorage.getItem('bhm_ads_selected_acc') || '{}')
        ?.name || '';
    this.customerId =
      JSON.parse(sessionStorage.getItem('bhm_ads_selected_acc') || '{}')
        ?.customerId || '';
    this.accessToken =
      JSON.parse(sessionStorage.getItem('bhm_ads_info') || '{}')?.accessToken ||
      '';

    if (this.websiteUrl != '') {
      this.selectedStepIndex++;
    }

    if (this.customerId != '' && this.accessToken != '') {
      this.selectedStepIndex++;
    }

    sessionStorage.removeItem('bhm_ads_website_url');
    sessionStorage.removeItem('bhm_ads_info');
    sessionStorage.removeItem('bhm_ads_selected_acc');
  }

  ngOnDestroy(): void {
    if (this.isDarkMode) {
      document.body.classList.add('dark-theme');
    }
    sessionStorage.removeItem('bhm_ads_website_url');
    sessionStorage.removeItem('bhm_ads_info');
    sessionStorage.removeItem('bhm_ads_selected_acc');
  }

  public updateStepIndex(index: number): void {
    if (this.websiteUrl == '' && index > 0) return;
    if (this.selectedEmail == '' && index > 1) return;
    if (this.customerAdsAccount.length == 0 && index > 2) return;

    this.selectedStepIndex = index;
  }

  public goToStepIndex(): void {
    this.selectedStepIndex++;
  }

  public goToPreviousIndex(): void {
    if (this.selectedStepIndex == 0) {
      // this.goToProjectsPage();
      window.history.back();
      return;
    }
    this.selectedStepIndex--;
  }

  public emailSelected(account: any): void {
    this.selectedEmail = account.name;
    this.customerId = account.customerId;
    this.localStorageService.set('bhm_ads_selected_acc', account);
    sessionStorage.setItem('bhm_ads_selected_acc', JSON.stringify(account));

    this.goToStepIndex();
  }

  public websiteUrlChanged(): void {
    this.websiteUrl = this.websiteUrl.trim();

    if (this.websiteUrl == '' || !this.websiteUrl.startsWith('http')) {
      this.websiteUrlError = 'Please enter a valid URL!';
      return;
    }

    this.websiteUrlError = '';

    sessionStorage.setItem('bhm_ads_website_url', this.websiteUrl);

    this.goToStepIndex();
  }

  public connectNewAccount(): void {
    this.selectedEmail = '';

    const popup = window.open(
      'https://ads.behamics.com/google-ads/auth',
      'googleAuth',
      'popup=1,width=600,height=700'
    );
    window.addEventListener(
      'message',
      (event) => {
        if (event.data.type === 'GoogleLogin') {
          this.connectionUnsuccessful = false;
          const { result } = event.data;
          if (result) {
            this.customerAdsAccount = result?.customers || [];
            this.accessToken = result?.accessToken;
            this.localStorageService.set('bhm_ads_info', result);
            sessionStorage.setItem('bhm_ads_info', JSON.stringify(result));
          }
        } else {
          this.connectionUnsuccessful = true;
          console.log('Event: ', event);
        }
      },
      { once: true }
    );
  }

  public extensionButtonClicked(): void {
    // install extension
    if (!this.extensionInstalled) {
      window.open(
        'https://chromewebstore.google.com/detail/ads-copilot/ccmdjghjdgnacbakhbpacafkpehlpajg',
        '_blank'
      );

      this.checkingExtensionStatus = true;
    }
    if (this.checkingExtensionStatus && !this.extensionInstalled) {
      if (!this.checkingExtensionStatusInterval) {
        this.checkingExtensionStatusInterval = setInterval(() => {
          this.checkExtensionStatus();
        }, this.checkingExtensionStatusIntervalTime);
      }

      // for testing
      // setTimeout(() => {
      //   this.checkingExtensionStatus = false;
      //   this.extensionInstalled = true;

      //   this.createProject();
      // }, 2000);
    }
    if (this.extensionInstalled) {
      clearInterval(this.checkingExtensionStatusInterval);
    }
  }

  public checkExtensionStatus(): void {
    fetch(
      'chrome-extension://ccmdjghjdgnacbakhbpacafkpehlpajg/behamics_check.json'
    )
      .then((response) => response.json())
      .then((data) => {
        console.log('✅ Extension is installed!', data);
        this.checkingExtensionStatus = false;
        this.extensionInstalled = true;
        clearInterval(this.checkingExtensionStatusInterval);

        this.createProject();
      })
      .catch(() => {
        console.log('❌ Extension is NOT installed.');
        this.checkingExtensionStatus = true;
        this.extensionInstalled = false;
      });
  }

  public createProject(): void {
    this.adsService
      .createProject({
        customerId: this.customerId,
        url: this.websiteUrl,
        accessToken: this.accessToken,
      })
      .subscribe({
        next: () => {
          this.redirectToDashboard();
        },
        error: (error) => {
          console.log(error);
        },
      });
  }

  public redirectToDashboard(): void {
    this.router.navigate(['ads']);
  }

  public goToProjectsPage(): void {
    this.router.navigate(['ads/projects']);
  }
}
